import { axios } from "@axios";
import { useQuery, useMutation } from "react-query";
import {
  MutationConfig,
} from "../../lib/react-query";

export type CreateApplicationPayload = {
  borrowerId: string;
  offerId: string;
  redirectUrl: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  pinCode?: string;
  address?: string;
  country?: string;
  state?: string;
  city?: string;
  region?: string;
};

export const createApplication = (
  payload: CreateApplicationPayload
): Promise<any> => {
  return axios.post("/application/create-application", payload);
};

export const getAllApplication = (
  userId: string,
  params: any
): Promise<any> => {
  return axios.get(`/application/get-all-application/${userId}`, { params });
};
type CreateApplicationFnType = typeof createApplication;

export const useCreateApplicationMutation = (
  config?: MutationConfig<CreateApplicationFnType>
) => {
  return useMutation(createApplication, config);
};

export const useGetAllApplicationQuery = ({
  userId,
  params,
  config,
}: {
  userId: string;
  params: any;
  config?: any;
}) => {
  return useQuery(
    ["getAllApplication", userId, params],
    () => getAllApplication(userId, params),
    {
      select: (res) => res.data,
      ...config,
    }
  );
};
